import { Navigate, Outlet } from 'react-router'

import { ROUTES } from '../../constants/routes'
import { useSession } from '../../hooks/useSession'
import AppHeader from '../AppHeader'
import Footer from '../Footer'
import { MainContent } from '../misc/MainContent'

export default function AccountLayout() {
  const session = useSession()

  if (session.isAuthenticated) {
    return <Navigate to={ROUTES.index} />
  }

  return (
    <>
      <AppHeader />

      <MainContent>
        <Outlet />
      </MainContent>

      <Footer />
    </>
  )
}
